// src/components/About.js
import React from 'react';
import Home from '../Home/Home';

const About = () => {
  return ( 
   <Home>
      <div className="container">
        <h1 className='about_us_title'>About Us: Udaan</h1>

        <h2 style={{ marginTop: "20px" }}>Introduction:</h2>
        <p>
          Udaan is a young and aspiring non-profit, tax-exempt charitable organization in Northern Delaware that strives to espouse, celebrate, and promote the riches of the Bengali culture. Udaan also seeks to educate the greater Delaware Valley community at large about the various aspects integral to the fabric of Indian life. To this end, Udaan provides a platform for cultural and social exchanges to generate appreciation and understanding of Indian ethos and philosophy among the people of this area.
        </p>
        <p>
          Udaan was born out of an insatiable desire to relive a multifaceted cultural experience through a wide variety of community events that explore the essence of what Bengal is all about, including music, art, entertainment, and of course, food — all in the spirit of fun, having a good time with family and friends. The organization was founded by fun-loving individuals who volunteer their time and effort in bringing this experience to our community. With open arms and soaring aspirations, Udaan welcomes not only the Bengali-speaking expatriate community, but the entire Indian diaspora, as well as individuals of all nationalities. We at Udaan believe that the opportunity to showcase our culture is a privilege and we invite you to share in this experience and help enrich the social fabric of the larger community.
        </p>
        <p>
          Among other events, Udaan Organizes...
        </p>
        <ul>
          <li>DURGA PUJA</li>
          <li>SARASWATI PUJA</li>
          <li>NABOBORSHO</li>
          <li>PICNIC</li>
        </ul>

        <h2>Mission:</h2>
        <p>
          Udaan was born out of an insatiable desire to relive a multifaceted cultural experience through a wide variety of community events that explore the essence of what Bengal is all about, including music, art, entertainment, and of course, food — all in the spirit of fun, having a good time with family and friends.
        </p>
        <p>
          Cultural programs and dramas
        </p>
        <p>
          Programs for the children
        </p>
        <p>
          Picnics and outings
        </p>
        <p>
          Athletic activities
        </p>
        <p>
          Celebration of ethnically oriented Pujas
        </p>
        <p>
          Interaction initiatives with similar other cultural groups.
        </p>

      
      </div>
    </Home>
  );
};

export default About;